import { render, staticRenderFns } from "./circularprogressbar.vue?vue&type=template&id=1af545b3&scoped=true&"
import script from "./circularprogressbar.vue?vue&type=script&lang=js&"
export * from "./circularprogressbar.vue?vue&type=script&lang=js&"
import style0 from "./circularprogressbar.vue?vue&type=style&index=0&id=1af545b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af545b3",
  null
  
)

export default component.exports